import { ISyncPublishResult } from '../controllers/DatasourcePublishResultCtrl';
import { Module } from '../Module';
import {
  IDatasourcePublishRemoteRefreshScheduleDialogScope,
  PublishDatasourceAction,
} from '../services/PublishDatasourceAction';

interface CreateDatasourceExtractRemoteRefreshScope extends IDatasourcePublishRemoteRefreshScheduleDialogScope {
  publishResult: ISyncPublishResult;
}

Module.instance().directive('tbDatasourceExtractRemoteRefreshScheduler',
  ['$translate',
    'PublishDatasourceAction',

    ($translate: ng.translate.ITranslateService,
      PublishDatasourceAction: PublishDatasourceAction) => {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          dataSourceInfo: '=',
          editorViewModel: '=',
          publishResult: '=',
          remoteAgentOptions: '=',
          scheduleInfo: '=',
          editModel: '='
        },
        templateUrl: 'datasourcePublishRemoteRefreshScheduleDialog.html',
        link: (scope: CreateDatasourceExtractRemoteRefreshScope) => {
          PublishDatasourceAction.remoteRefreshScheduleDialogScopeSetup(scope.publishResult, scope, false, true);
        }
      };
    }
  ]
);
